import React from 'react';
import ArcGISMap from './components/ArcGISMap';

function App() {
  return (
    <main style={{ height: '100vh' }}>
      <ArcGISMap />
    </main>
  );
}

export default App;